var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCi21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_718",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 0H0V70H70V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.099 21.4369L35.0002 19.4049L39.9016 21.4369C40.5582 21.708 41.3124 21.6224 41.8922 21.2018C42.4691 20.7819 42.7863 20.0915 42.7303 19.3804L42.3133 14.0912L45.7599 10.056C46.2235 9.51441 46.3711 8.76916 46.151 8.09089C45.9308 7.41126 45.3731 6.8957 44.6785 6.73027L39.5201 5.49132L36.7488 0.966482C36.0112 -0.322229 33.9892 -0.322092 33.2516 0.966482L30.4803 5.49132L25.3219 6.73027C24.6274 6.8957 24.0695 7.41126 23.8495 8.09089C23.6293 8.76916 23.777 9.51441 24.2404 10.056L27.6871 14.0912L27.2701 19.3804C27.2141 20.0915 27.5312 20.7821 28.1083 21.2018C28.6867 21.6202 29.44 21.7104 30.099 21.4369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9001 16.1587C69.6801 15.479 69.1222 14.9634 68.4277 14.798L63.2693 13.5591L60.4981 9.03422C60.1248 8.42569 59.463 8.05518 58.7494 8.05518C58.0357 8.05518 57.374 8.42583 57.0008 9.03422L54.2295 13.5591L49.0711 14.798C48.3765 14.9634 47.8188 15.479 47.5986 16.1587C47.3785 16.8369 47.5262 17.5821 47.9897 18.1237L51.4364 22.159L51.0193 27.4482C50.9633 28.1592 51.2805 28.8498 51.8574 29.2696C52.4357 29.688 53.189 29.7782 53.8481 29.5048L58.7494 27.4727L63.6508 29.5048C64.3075 29.7758 65.0616 29.6901 65.6415 29.2696C66.2184 28.8497 66.5356 28.1592 66.4795 27.4482L66.0625 22.159L69.5092 18.1237C69.9727 17.5821 70.1203 16.8369 69.9001 16.1587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9372 29.6605C17.3637 29.6605 17.7862 29.528 18.1431 29.2696C18.72 28.8497 19.0372 28.1592 18.9811 27.4482L18.5641 22.159L22.0108 18.1237C22.4743 17.5821 22.6219 16.8369 22.4018 16.1587C22.1817 15.479 21.6239 14.9634 20.9293 14.798L15.771 13.5591L12.9997 9.03422C12.6264 8.42569 11.9648 8.05518 11.251 8.05518C10.5374 8.05518 9.87564 8.42583 9.5024 9.03422L6.73111 13.5591L1.5727 14.798C0.878176 14.9634 0.320363 15.479 0.100246 16.1587C-0.119872 16.8369 0.0277848 17.5821 0.491261 18.1237L3.93794 22.159L3.52095 27.4482C3.4649 28.1592 3.78208 28.8498 4.35904 29.2696C4.93736 29.688 5.69067 29.7782 6.34967 29.5048L11.251 27.4727L16.1524 29.5048C16.4053 29.6086 16.6719 29.6605 16.9372 29.6605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1423 49.3309L56.7155 63.2393C56.1057 66.7216 53.0829 69.2617 49.5487 69.2617H35.5528C34.5752 69.2617 33.6169 69.0663 32.7295 68.7013C31.8423 68.3321 31.0261 67.7934 30.3357 67.1017C30.2932 67.0592 30.2494 67.0168 30.2057 66.9745V43.8717L30.2987 43.8389C32.2715 43.1307 33.8096 41.5503 34.4604 39.5569L35.684 35.6413L37.3329 30.3653C37.8182 28.8819 39.4123 28.0739 40.8971 28.5592C43.6151 29.4452 45.3432 31.9717 45.3432 34.6829C45.3432 35.3473 45.2394 36.0227 45.0206 36.6871L43.1831 42.7165H53.5832C57.0887 42.7165 59.7465 45.8788 59.1423 49.3309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0646 70.0002H14.5715C13.4454 70.0002 12.5326 69.0872 12.5326 67.9612V43.3757C12.5326 42.2496 13.4454 41.3367 14.5715 41.3367H24.0646C25.1908 41.3367 26.1037 42.2496 26.1037 43.3757V67.9612C26.1037 69.0872 25.1908 70.0002 24.0646 70.0002Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCi21);
export default __webpack_public_path__ + "static/media/ci-2-1.a45fe1f80bf779f8bf576792cd7a98b7.svg";
export { ForwardRef as ReactComponent };